// src/pages/Convocations/ConvocationsPage.jsx

import React from "react";

import {
  ToastContainer,
} from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

import useScrollToTop from "../../hooks/useScollToTop";

import ScrollIndicator from "../Home/ScrollIndicator";

import EventDetailsModal from "../PresencePro/CalendrierLigue/EventDetailsModal";

import ObservationsModal from "./ObservationsModal";

import ResponseConvocationModal from "./ResponseConvocationModal";

import ConvocationsHero from "./components/ConvocationsHero";

import ConvocationsStats from "./components/ConvocationsStats";

import ConvocationsFilters from "./components/ConvocationsFilters";

import ConvocationsList from "./components/ConvocationsList";

import useConvocationsPage from "./hooks/useConvocationsPage";

export default function ConvocationsPage() {
  useScrollToTop();

  const {
    userRole,

    actors,
    convocations,
    filteredConvocations,

    stats,
    typeOptions,
    posteOptions,

    filters,
    activeFilterCount,

    loading,
    refreshing,
    savingResponse,

    selectedEvent,
    textModal,
    responseModal,

    setFilter,
    resetFilters,
    filterByStatus,
    showPendingConvocations,

    loadConvocations,

    openEventModal,
    closeEventModal,

    openTextModal,
    closeTextModal,

    openResponseModal,
    closeResponseModal,

    handleResponseSubmit,
  } = useConvocationsPage();

  return (
    <main
      className="
        relative min-h-screen
        overflow-hidden
        bg-slate-50
        pb-14
        pt-[105px]
        text-slate-900
        dark:bg-slate-950
        dark:text-slate-50
        md:pt-[125px]
      "
    >
      <ScrollIndicator />

      <div
        aria-hidden="true"
        className="
          pointer-events-none
          absolute -left-40 top-52
          h-96 w-96
          rounded-full
          bg-blue-500/5
          blur-3xl
          dark:bg-blue-500/10
        "
      />

      <div
        aria-hidden="true"
        className="
          pointer-events-none
          absolute -right-40
          top-[700px]
          h-96 w-96
          rounded-full
          bg-orange-400/5
          blur-3xl
          dark:bg-orange-500/10
        "
      />

      <div
        className="
          relative z-10
          mx-auto w-full
          max-w-[1500px]
          space-y-5
          px-3
          sm:px-5
          lg:px-8
        "
      >
        <ConvocationsHero
          actors={actors}
          pendingCount={
            stats.pendingFuture
          }
          refreshing={refreshing}
          onRefresh={() =>
            loadConvocations({
              silent: true,
            })
          }
          onShowPending={
            showPendingConvocations
          }
        />

        <ConvocationsStats
          stats={stats}
          selectedStatus={
            filters.selectedStatus
          }
          onSelectStatus={
            filterByStatus
          }
        />

        <ConvocationsFilters
          filters={filters}
          actors={actors}
          typeOptions={typeOptions}
          posteOptions={
            posteOptions
          }
          activeFilterCount={
            activeFilterCount
          }
          resultCount={
            filteredConvocations.length
          }
          onChange={setFilter}
          onReset={resetFilters}
        />

        <ConvocationsList
          actors={actors}
          allConvocations={
            convocations
          }
          convocations={
            filteredConvocations
          }
          loading={loading}
          saving={savingResponse}
          onOpenEvent={
            openEventModal
          }
          onOpenText={openTextModal}
          onRespond={
            openResponseModal
          }
          onReset={resetFilters}
          onRefresh={() =>
            loadConvocations({
              silent: true,
            })
          }
        />
      </div>

      {selectedEvent ? (
        <EventDetailsModal
          event={selectedEvent}
          isOpen={
            Boolean(selectedEvent)
          }
          onClose={
            closeEventModal
          }
          userRole={userRole}
        />
      ) : null}

      <ObservationsModal
        title={textModal.title}
        content={
          textModal.content
        }
        allowHtml={
          textModal.allowHtml
        }
        isOpen={textModal.isOpen}
        onClose={closeTextModal}
      />

      <ResponseConvocationModal
        isOpen={
          responseModal.isOpen
        }
        onClose={
          closeResponseModal
        }
        onSubmit={
          handleResponseSubmit
        }
        loading={
          savingResponse
        }
        convocation={
          responseModal.convocation
        }
        mode={responseModal.mode}
      />

      <ToastContainer />
    </main>
  );
}